<template>
    <li
        class="group flex flex-row items-center justify-between px-4 py-3 hover:bg-slate-50"
        @click="$emit('deleteTag')"
    >
        <div class="flex flex-col">
            <div class="text-sm font-medium text-slate-900">{{ name }}</div>
        </div>
        <Icon
            :icon="IconEnums.TRASH"
            class="hidden h-4 w-4 cursor-pointer text-rose-500 group-hover:block"
        />
    </li>
</template>

<script>
import { getProperty } from "@/utils/object";
import Icon from "@/components/icons/BaseIcon";
import { IconEnums } from "@/utils/icons";

export default {
    name: "TagItem",
    components: { Icon },
    props: {
        tag: {
            type: Object,
            default: () => {},
        },
    },
    data: () => ({
        IconEnums,
    }),
    computed: {
        /**
         * @type {string}
         */
        id() {
            return getProperty(this.tag, "id", null);
        },

        /**
         * @type {string}
         */
        name() {
            return getProperty(this.tag, "name", "Anonymous");
        },
    },
};
</script>
